import React from 'react';
import Button, { VARIANTS } from 'common/components/Button';
import { I18n } from 'common/i18n';

const scope = 'shared.visualizations.panes.data';
interface AddAllButtonProps {
  disabled: boolean;
  onClick: () => void;
}

const AddAllButton = ({ disabled, onClick }: AddAllButtonProps) => {
  return (
    <div className="add-all-button" aria-label={I18n.t('fields.columns.select_all', { scope })}>
      <Button className="add-all" disabled={disabled} variant={VARIANTS.LINK} onClick={onClick}>
        {I18n.t('fields.columns.select_all', { scope })}
      </Button>
    </div>
  );
};

export default AddAllButton;
